import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")

  return (_openBlock(), _createBlock(_component_a_button, _mergeProps({
    type: _ctx.props.type,
    onClick: _ctx.fn
  }, _ctx.attrs, {
    loading: _ctx.props.loading,
    block: _ctx.props.block,
    ghost: _ctx.props.ghost,
    key: _ctx.props.key,
    disabled: _ctx.props.disabled,
    shape: _ctx.props.shape,
    htmlType: _ctx.props.htmlType,
    size: _ctx.props.size
  }), {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 16, ["type", "onClick", "loading", "block", "ghost", "disabled", "shape", "htmlType", "size"]))
}